import * as React from 'react';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';
import { IconActionChevronRight16, IconProductKey24 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';

interface IMyHomeTrapBannerProps {
  link: string;
  onClick: () => void;
}

export const MyHomeTrapBanner: React.FC<IMyHomeTrapBannerProps> = ({ link, onClick }) => {
  return (
    <a className={styles['wrapper']} href={link} onClick={onClick} target="_blank" rel="noreferrer">
      <div className={styles['heading']}>
        <div className={styles['icon']}>
          <IconProductKey24 color="icon-primary-default" />
        </div>

        <div className={styles['title']}>
          <ArticleHeading4 color="text-primary-default">Уже купили тут квартиру?</ArticleHeading4>
          <ArticleParagraph2 color="text-secondary-default">
            Следите за ростом её стоимости в сервисе Мой дом
          </ArticleParagraph2>
        </div>
      </div>

      <div className={styles['arrow-icon']}>
        <IconActionChevronRight16 color="icon-secondary-default" />
      </div>
    </a>
  );
};
